import { FC } from 'react';
import { appcuesPage } from 'telemetry';
import RouteChangeListener from '../routing/RouteChangeListener';

const AppCuesProvider: FC = () => {
  return <RouteChangeListener onRouteChange={appcuesPage} />;
};

export default AppCuesProvider;
